enum TypeCorrespond {
    CUBANACAN="CUBANACAN",
    TRANSCARGO="TRANSCARGO",
    PALCO="PALCO",
    EMCI="EMCI"
}

export default TypeCorrespond;